import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import ErrorPage from '../ErrorPage';
import Administration from '../administration/Administration';

const PrivateRoute = () => {
    const isAdmin = useSelector((state: RootState) => state.user.isAdmin);
    return isAdmin ? <Administration /> : <ErrorPage />;
};

export default PrivateRoute;
